import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import '../css/ContactSection.css';

const ContactSection: React.FC = () => {
  const [state, handleSubmit] = useForm("mqayrpyq");

  if (state.succeeded) {
    return (
      <div className="contact-section">
        <div className="contact-content">
          <div className="contact-success">
            <h2 className="contact-title">Thank you for your interest!</h2>
            <p className="contact-description">
              We've received your message and will get back to you shortly to schedule your demo.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-section">
      <div className="contact-content">
        <div className="contact-left">
          <h2 className="contact-title">Ready to see Crikey<sup>ai</sup> in action?</h2>
          <p className="contact-description">
            Request a live demo and see how our AI claims agents improve efficiency, 
            accuracy, and the claim experience – instantly.
          </p>
          <div className="contact-benefits">
            <div className="benefit-item">
              <span className="benefit-check">✓</span>
              <span>See live AI claims processing</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✓</span>
              <span>Learn about implementation</span>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✓</span>
              <span>Get your questions answered</span>
            </div>
          </div>
        </div>

        <div className="contact-right">
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name" className="form-label">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="John Smith"
                className="form-input"
                required
              />
              <ValidationError 
                prefix="Name" 
                field="name"
                errors={state.errors}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="John.Smith@outlook.com"
                className="form-input"
                required
              />
              <ValidationError 
                prefix="Email" 
                field="email"
                errors={state.errors}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea
                id="message"
                name="message"
                placeholder="Message"
                className="form-textarea"
                rows={5}
                required
              />
              <ValidationError 
                prefix="Message" 
                field="message"
                errors={state.errors}
              />
            </div>

            <input
              type="text"
              name="_gotcha"
              placeholder="Smith"
              style={{ display: 'none' }}
              tabIndex={-1}
              autoComplete="off"
            />

            <button 
              type="submit" 
              className="form-submit-button"
              disabled={state.submitting}
            >
              {state.submitting ? 'Sending...' : 'Send'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;